import React from 'react';

import classnames from 'classnames';

import Typography from 'components/uiLibrary/Typography';

import EntityName from 'components/Globals/EntityName';

import { TP } from 'constants/index';

import { useDialogs } from 'utils/hooks/useDialogs';

import { ENTITY_TYPES } from 'operabase-router/constants';

import classes from './ProSlugCollapsed/ProSlugCollapsed.module.scss';

export const DirectorConductor = ({ directors, conductors, crewCount, castCount, t, trackingData, isJumpInSlug }) => {
  const { isJumpInSelectProductionsModalOpen } = useDialogs();

  return (
    <div
      className={classnames(classes.crew, {
        [classes.jumpInCrew]: !!isJumpInSlug && !isJumpInSelectProductionsModalOpen,
      })}
    >
      <div className={classes.director}>
        {directors?.length > 0 && (
          <div className={classes.director__block}>
            <Typography size={12} color="secondary" className={classes.title}>
              D:
            </Typography>
            <Typography className={classes.director__block_namesList}>
              {directors?.map((contributor, i) => (
                <Typography key={contributor?.id} className={classes.item}>
                  <EntityName
                    entityType={ENTITY_TYPES.PROFILE}
                    entity={contributor}
                    isRaw
                    trackingData={trackingData}
                  />
                </Typography>
              ))}
            </Typography>
          </div>
        )}
        {crewCount > 0 && (!isJumpInSlug || isJumpInSelectProductionsModalOpen) && (
          <Typography
            size={12}
            color="territory"
            className={classnames(classes.crewText, {
              [classes.noMainCrew]: !directors || !directors.length,
            })}
          >
            {t(`${TP}.FN_CREW_TITLE`)} <strong>({crewCount})</strong>
          </Typography>
        )}
      </div>
      <div className={classes.conductor}>
        {conductors?.length > 0 && (
          <div className={classes.conductor__block}>
            <Typography size="12" color="secondary" className={classes.title}>
              C:
            </Typography>
            <span className={classes.conductor__block_namesList}>
              {conductors?.map((contributor, i) => (
                <Typography size={12} key={contributor?.id} className={classes.item}>
                  <EntityName
                    entityType={ENTITY_TYPES.PROFILE}
                    entity={contributor}
                    isRaw
                    trackingData={trackingData}
                  />
                </Typography>
              ))}
            </span>
          </div>
        )}
        {castCount > 0 && (!isJumpInSlug || isJumpInSelectProductionsModalOpen) && (
          <Typography
            size="12"
            color="territory"
            className={classnames(classes.castCount, {
              [classes.noMainCrew]: !conductors || !conductors.length,
            })}
          >
            {t(`${TP}.FN_CAST`)} <strong>({castCount})</strong>
          </Typography>
        )}
      </div>
    </div>
  );
};
